
import { objToUrlParam } from "../../lib/url-util";
import {deep_copy} from "../../lib/js-utils";

const NAVIGATE_PATH = "NAVIGATE_PATH";

const navigatePath = (path_, args) => {
  let path = deep_copy(path_);
  if (args) {
    path += objToUrlParam(args);
  }
  return (dispatch) => {
    dispatch({
      type: NAVIGATE_PATH,
      payload: path,
      push: false,
    });
  };
};

const pushPath = (path) => {
  return (dispatch) => {
    dispatch({
      type: NAVIGATE_PATH,
      payload: path,
      push: true,
    });
  };
};


const navigateReducer = (
  state = { path: null },
  action) => {

  switch(action.type) {
    case NAVIGATE_PATH:
      return {
        path: action.payload,
        push: action.push,
      }
    default:
      return state;
  }
};

export { navigatePath, navigateReducer, NAVIGATE_PATH, pushPath };


